import { PartnerBoardFeature } from '../store/partnerManagerSlice';
import useFeatureAccess from '../util/useFeatureAccess';
import React from 'react';
import NoMatch from '../components/nomatch';
import { usePbSelector } from '../store/pbStoreHooks';
import { Outlet } from 'react-router-dom';

const withAuthorization =
    <P extends object>(
        WrappedComponent: React.ComponentType<P>,
        feature: PartnerBoardFeature
    ) =>
    (props: P) => {
        const selectedPartner = usePbSelector(
            (state) => state.partnerManager.selectedPartner
        );
        const { canReadFeature } = useFeatureAccess({
            feature_access: selectedPartner?.feature_access,
        });

        if (!selectedPartner) {
            return null;
        }

        if (!canReadFeature(feature)) {
            return <NoMatch />;
        }

        return (
            <WrappedComponent {...props}>
                <Outlet />
            </WrappedComponent>
        );
    };

export default withAuthorization;
